/** One observation set as a line of text. The holding bay and recovery record
 *  the same set (panels/FlowPanel VitalsDialog), and each used to spell out
 *  its own partial line -- recovery dropped RR, temperature and consciousness,
 *  the holding bay dropped pain and the note. */
export function vitalsLine(v) {
  return (
    `BP ${v.systolic_bp ?? "—"}/${v.diastolic_bp ?? "—"}, HR ${v.heart_rate ?? "—"}, ` +
    `RR ${v.respiratory_rate ?? "—"}, SpO₂ ${v.spo2 ?? "—"}%, temp ${v.temperature ?? "—"}, ` +
    `pain ${v.pain_score ?? "—"}` +
    (v.consciousness ? ` · ${v.consciousness}` : "") +
    (v.notes ? ` · Note: ${v.notes}` : "") +
    (v.recorded_by_name ? ` · ${v.recorded_by_name}` : "")
  );
}
